// extracted by mini-css-extract-plugin
export default {"styled_icon":"styled_styled_icon__jymOM"};